import { getRiskManagementDateRange } from "@/features/risk-management/logic/date-helper";

const productParamMapper: Record<string, Record<string, any>> = {
  "demurrage-and-detention": {
    limit: 50,
    view: "table",
    direction: "IMPORT",
    page: 1
  },
  shipments: {
    limit: 50,
    tab: "active",
    page: 1
  },
  "port-congestion": {
    showListOfPorts: true,
    showAllPorts: true,
    isControlTowerViewEnabled: true
  },
  "risk-management": {
    dateType: "ETA"
  }
};

export const hyperlinkEnricher = (hyperlink: string) => {
  const url = new URL(hyperlink, globalThis.location.origin);

  const pathName = url.pathname.toLowerCase();
  const productKey = Object.keys(productParamMapper).find((key) => pathName.includes(key));

  if (productKey) {
    let params = productParamMapper[productKey];

    // Compute date range at click time for risk-management to avoid stale dates
    if (productKey === "risk-management") {
      params = { ...params, ...getRiskManagementDateRange() };
    }

    for (const [param, value] of Object.entries(params)) {
      // Only set default if parameter doesn't already exist
      if (!url.searchParams.has(param)) {
        const stringValue = typeof value === "object" && value !== null ? JSON.stringify(value) : String(value);
        url.searchParams.set(param, stringValue);
      }
    }
  }

  return url;
};
